import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.trim.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import i18next from "i18next";
import { computed, makeObservable, observable, runInAction } from "mobx";
import JSSoup from "jssoup";
import BrandRules from "../../utils/BrandRules";
var SearchModel = (_class = /*#__PURE__*/function () {
  function SearchModel(platformUtil, analyticsModel) {
    _classCallCheck(this, SearchModel);

    _defineProperty(this, "platformUtil", void 0);

    _defineProperty(this, "analyticsModel", void 0);

    _initializerDefineProperty(this, "_appAttributes", _descriptor, this);

    _initializerDefineProperty(this, "_menuSearchList", _descriptor2, this);

    _initializerDefineProperty(this, "_showSearchModal", _descriptor3, this);

    _initializerDefineProperty(this, "_searchText", _descriptor4, this);

    _initializerDefineProperty(this, "_positionalIndexCounter", _descriptor5, this);

    _initializerDefineProperty(this, "_isMenuSearchDisableBySession", _descriptor6, this);

    _initializerDefineProperty(this, "_isMenuSearchDisableByCookie", _descriptor7, this);

    _initializerDefineProperty(this, "_isMenuSearchDisabledByEvent", _descriptor8, this);

    _initializerDefineProperty(this, "_searchInputBoxText", _descriptor9, this);

    this.platformUtil = platformUtil;
    this.analyticsModel = analyticsModel;
    makeObservable(this);

    this._checkIsMenuSearchEnabledFromCookie();

    this._checkIsMenuSearchEnabledFromSession();
  }

  _createClass(SearchModel, [{
    key: "setAppAttributesData",
    value: function setAppAttributesData(_appAttributes) {
      var _this = this;

      runInAction(function () {
        _this._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "isGridView",
    value: function isGridView() {
      var _this$_appAttributes, _this$_appAttributes$, _this$_appAttributes2, _this$_appAttributes3, _this$_appAttributes4, _this$_appAttributes5;

      if (((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.isMenuImagesSupported) === undefined || ((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.configs) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.isMenuImagesSupported) === null || ((_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : (_this$_appAttributes5 = _this$_appAttributes4.configs) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5.isMenuImagesSupported) === "true") {
        return true;
      }

      return false;
    }
  }, {
    key: "_getItemIndicatorKeyword",
    value: function _getItemIndicatorKeyword(specialInfo) {
      var itemIndicatorKeyword = [];

      for (var i = 0; i < specialInfo.length; i++) {
        var indicator = specialInfo[i];

        if (indicator.code === "GS") {
          itemIndicatorKeyword.push("# Gluten Free");
        } else if (indicator.code === "NI") {
          itemIndicatorKeyword.push("# New");
        }
      }

      return itemIndicatorKeyword;
    }
  }, {
    key: "_getItemKeyWord",
    value: function _getItemKeyWord(m) {
      var newKeyWordArray = _toConsumableArray((m === null || m === void 0 ? void 0 : m.keywords) || []); // const breadCrumbArray = m.breadCrumbSlug.split("/");
      // const parentCategory = breadCrumbArray[breadCrumbArray.length - 1];
      // parentCategory.includes("-")
      //   ? newKeyWordArray.push(parentCategory.split("-").join(" "))
      //   : newKeyWordArray.push(parentCategory);


      if (m.specialInfoIcons && m.specialInfoIcons.length > 0) {
        var indicatorArray = this._getItemIndicatorKeyword(m.specialInfoIcons);

        return [].concat(_toConsumableArray(newKeyWordArray), _toConsumableArray(indicatorArray));
      } else {
        return newKeyWordArray;
      }
    }
  }, {
    key: "getImageUrl",
    value: function getImageUrl(url) {
      if (url === null) {
        var _this$_appAttributes6, _this$_appAttributes7;

        if (((_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : (_this$_appAttributes7 = _this$_appAttributes6.concept) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7.conceptCode) === "LH") {
          var _this$_appAttributes8, _this$_appAttributes9;

          return (_this$_appAttributes8 = this._appAttributes) === null || _this$_appAttributes8 === void 0 ? void 0 : (_this$_appAttributes9 = _this$_appAttributes8.configs) === null || _this$_appAttributes9 === void 0 ? void 0 : _this$_appAttributes9.mediaRoot_menulistingimage_url;
        } else {
          var _this$_appAttributes10, _this$_appAttributes11;

          return (_this$_appAttributes10 = this._appAttributes) === null || _this$_appAttributes10 === void 0 ? void 0 : (_this$_appAttributes11 = _this$_appAttributes10.configs) === null || _this$_appAttributes11 === void 0 ? void 0 : _this$_appAttributes11.mediaRoot_stoneimage_url;
        }
      }

      return url;
    }
  }, {
    key: "_add",
    value: function _add(m, index) {
      var _itemDescription;

      var itemKeyWords = this._getItemKeyWord(m); // itemKeyWords.push(m.category);


      var itemDescription = "";

      try {
        var soup = new JSSoup(m.longDescription);
        var tempSoup = soup;
        tempSoup.extract();

        var _tempSoup$contents = _slicedToArray(tempSoup.contents, 2),
            firstContent = _tempSoup$contents[0],
            secondContent = _tempSoup$contents[1];

        secondContent === null || secondContent === void 0 ? void 0 : secondContent.extract();
        var createYourOwnPasta = secondContent && secondContent.contents && secondContent.contents.length && secondContent.contents[1] ? secondContent === null || secondContent === void 0 ? void 0 : secondContent.contents[1] : null;
        var firstContentText = firstContent.text || firstContent._text || null;
        var secondContentText = (secondContent === null || secondContent === void 0 ? void 0 : secondContent.text) || (secondContent === null || secondContent === void 0 ? void 0 : secondContent._text) || null;
        var isFaultyFirstContentText = firstContentText.includes("{");
        var filteredString = isFaultyFirstContentText ? secondContentText : firstContentText;
        var mainString = !isFaultyFirstContentText && secondContentText ? "".concat(firstContentText).concat(secondContentText) : filteredString;
        var extractedString = (createYourOwnPasta === null || createYourOwnPasta === void 0 ? void 0 : createYourOwnPasta.text) || mainString;
        itemDescription = !extractedString || extractedString === "null" || extractedString === "undefined" ? "" : extractedString.replace(/&nbsp;/g, " ").replace(/&#39;/g, "'").replace(/&amp;/g, "&").replace(/&#160;/g, " ").replace(/&iuml;/g, "ï").replace(/&egrave;/g, "è");
      } catch (error) {
        console.log(error, "error");
        itemDescription = m.longDescription;
      }

      return {
        id: m.id,
        name: m.name,
        imageURL: this.getImageUrl(m.imageURL),
        description: itemDescription,
        keywords: itemKeyWords,
        price: m.price,
        category: m.category,
        isImageSupported: this.isGridView(),
        slug: m.slug,
        breadCrumbSlug: m.breadCrumbSlug,
        imgAltText: m.imgAltText,
        positionalIndex: this._positionalIndexCounter++,
        searchableDesc: this._getSearchableDesc((_itemDescription = itemDescription) === null || _itemDescription === void 0 ? void 0 : _itemDescription.toLowerCase())
      };
    }
  }, {
    key: "_getProductsRecurse",
    value: function _getProductsRecurse(cat, categoryName) {
      var categoryPath = categoryName.length === 0 ? cat.name : categoryName + " > " + cat.name;
      var products = cat.menu && cat.menu.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          category: categoryPath
        });
      }) || [];

      if (cat.menucategories) {
        var parentCategory = categoryPath;

        var _iterator = _createForOfIteratorHelper(cat.menucategories),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var subCat = _step.value;

            var p = this._getProductsRecurse(subCat, parentCategory);

            products = products.concat(p);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return products;
    }
  }, {
    key: "setMenuListData",
    value: function setMenuListData(_menu) {
      var _this2 = this;

      runInAction(function () {
        var _menu$subCategories;

        var menuItems = [];
        (_menu$subCategories = _menu.subCategories) === null || _menu$subCategories === void 0 ? void 0 : _menu$subCategories.forEach(function (cat, index) {
          var _BrandRules, _this2$_appAttributes;

          var externalLinkUrl = (_BrandRules = new BrandRules((_this2$_appAttributes = _this2._appAttributes) === null || _this2$_appAttributes === void 0 ? void 0 : _this2$_appAttributes.currentConceptCode)) === null || _BrandRules === void 0 ? void 0 : _BrandRules.externalLinkUrl(cat.slug);

          if (!(externalLinkUrl && (cat === null || cat === void 0 ? void 0 : cat.slug) === "happy-hour")) {
            var products = _this2._getProductsRecurse(cat, "");

            products.forEach(function (m, index) {
              menuItems.push(_this2._add(m, index));
            });
          }
        });
        _this2._menuSearchList = menuItems;
      });
    }
  }, {
    key: "_getMatchedWordsArray",
    value: function _getMatchedWordsArray(itemString) {
      var _this3 = this;

      var itemStringWordArray = itemString.split(" ");
      return itemStringWordArray.filter(function (word) {
        if (word.toLowerCase().indexOf(_this3._searchText.toLowerCase()) !== -1) {
          return true;
        } else {
          return false;
        }
      });
    }
  }, {
    key: "_getMenuItemString",
    value: function _getMenuItemString(item) {
      var _menuItemString;

      var menuItemString;

      if (item.searchableDesc) {
        menuItemString = item.name + " # " + item.searchableDesc + " # " + item.keywords.join(" # ");
      } else {
        menuItemString = item.name + " # " + item.keywords.join(" # ");
      }

      return (_menuItemString = menuItemString) === null || _menuItemString === void 0 ? void 0 : _menuItemString.toLowerCase();
    } // creating a description string which will used for filtering purpose

  }, {
    key: "_getSearchableDesc",
    value: function _getSearchableDesc(itemDescription) {
      var _this$_appAttributes12, _this$_appAttributes13, _this$_appAttributes14;

      var menuSearchKeywordExclusions = (_this$_appAttributes12 = this._appAttributes) === null || _this$_appAttributes12 === void 0 ? void 0 : (_this$_appAttributes13 = _this$_appAttributes12.configs) === null || _this$_appAttributes13 === void 0 ? void 0 : (_this$_appAttributes14 = _this$_appAttributes13.excludedMenuSearchKeywords) === null || _this$_appAttributes14 === void 0 ? void 0 : _this$_appAttributes14.split(",");

      if ((menuSearchKeywordExclusions === null || menuSearchKeywordExclusions === void 0 ? void 0 : menuSearchKeywordExclusions.length) > 0) {
        return menuSearchKeywordExclusions === null || menuSearchKeywordExclusions === void 0 ? void 0 : menuSearchKeywordExclusions.reduce(function (result, keyword) {
          var _keyword$toLowerCase;

          var _keyword = new RegExp(keyword === null || keyword === void 0 ? void 0 : (_keyword$toLowerCase = keyword.toLowerCase()) === null || _keyword$toLowerCase === void 0 ? void 0 : _keyword$toLowerCase.trim(), "g");

          return result === null || result === void 0 ? void 0 : result.replace(_keyword, "");
        }, itemDescription);
      }

      return itemDescription === null || itemDescription === void 0 ? void 0 : itemDescription.toLowerCase();
    }
  }, {
    key: "_filterByExcludedWord",
    value: function _filterByExcludedWord(filteredList) {
      var _this4 = this;

      return filteredList.filter(function (item) {
        var _this4$_appAttributes, _this4$_appAttributes2, _this4$_appAttributes3;

        var menuSearchKeywordExclusions = (_this4$_appAttributes = _this4._appAttributes) === null || _this4$_appAttributes === void 0 ? void 0 : (_this4$_appAttributes2 = _this4$_appAttributes.configs) === null || _this4$_appAttributes2 === void 0 ? void 0 : (_this4$_appAttributes3 = _this4$_appAttributes2.excludedMenuSearchKeywords) === null || _this4$_appAttributes3 === void 0 ? void 0 : _this4$_appAttributes3.split(",");

        if (menuSearchKeywordExclusions.length > 0) {
          var menuItemString = _this4._getMenuItemString(item);

          var matchedWordsArray = _this4._getMatchedWordsArray(menuItemString);

          var filteredMatchedWordArray = matchedWordsArray.filter(function (matchedWord) {
            return !menuSearchKeywordExclusions.includes(matchedWord.toLowerCase());
          });

          if (filteredMatchedWordArray.length > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      });
    }
  }, {
    key: "_filterBySearchText",
    value: function _filterBySearchText() {
      var _this5 = this;

      return this._menuSearchList.filter(function (item) {
        var menuItemString = _this5._getMenuItemString(item);

        if (menuItemString.indexOf(_this5._searchText.toLowerCase()) !== -1) {
          return true;
        } else {
          return false;
        }
      });
    }
  }, {
    key: "_filteredItemListArray",
    value: function _filteredItemListArray() {
      var _this$_appAttributes15;

      var filteredListBySearchText = this._filterBySearchText(); // const finalFilteredList = this._filterByExcludedWord(
      //   filteredListBySearchText,
      // );


      var menuSearchListItemIdArray = [];
      var uniqueFilteredList = filteredListBySearchText.filter(function (item) {
        if (menuSearchListItemIdArray.length > 0) {
          if (!menuSearchListItemIdArray.includes(item.id)) {
            menuSearchListItemIdArray.push(item.id);
            return true;
          }

          return false;
        } else {
          menuSearchListItemIdArray.push(item.id);
          return true;
        }
      });

      if (this.searchText.length <= 2) {
        uniqueFilteredList = uniqueFilteredList.slice(0, 10);
      }

      return new BrandRules(this === null || this === void 0 ? void 0 : (_this$_appAttributes15 = this._appAttributes) === null || _this$_appAttributes15 === void 0 ? void 0 : _this$_appAttributes15.currentConceptCode).sortMenuSearchResults(uniqueFilteredList, this.searchText.toLowerCase());
    }
  }, {
    key: "setMenuSearchABTest",
    value: function setMenuSearchABTest(searchDisabled) {
      var _this6 = this;

      runInAction(function () {
        _this6._isMenuSearchDisabledByEvent = searchDisabled + "";
      });
    }
  }, {
    key: "_checkIsMenuSearchEnabledFromSession",
    value: function _checkIsMenuSearchEnabledFromSession() {
      var _this$platformUtil,
          _this7 = this;

      (_this$platformUtil = this.platformUtil) === null || _this$platformUtil === void 0 ? void 0 : _this$platformUtil.getFromSessionStorage("WEB_MENU_SEARCH_DISABLE").then(function (value) {
        runInAction(function () {
          _this7._isMenuSearchDisableBySession = value !== null && value !== void 0 ? value : "false";
        });
      });
    }
  }, {
    key: "_checkIsMenuSearchEnabledFromCookie",
    value: function _checkIsMenuSearchEnabledFromCookie() {
      var _this$platformUtil2,
          _this8 = this;

      (_this$platformUtil2 = this.platformUtil) === null || _this$platformUtil2 === void 0 ? void 0 : _this$platformUtil2.getCookie("WEB_MENU_SEARCH_DISABLE").then(function (value) {
        runInAction(function () {
          _this8._isMenuSearchDisableByCookie = value !== null && value !== void 0 ? value : "false";
        });
      });
    }
  }, {
    key: "keywordConfirmationAnalytics",
    ///Analytics
    value: function keywordConfirmationAnalytics(text, isSuggested) {
      var _this$analyticsModel, _this$searchItems;

      (_this$analyticsModel = this.analyticsModel) === null || _this$analyticsModel === void 0 ? void 0 : _this$analyticsModel.dispatchKeywordSearchConfirmation(text, isSuggested, !(this._searchText && ((_this$searchItems = this.searchItems) === null || _this$searchItems === void 0 ? void 0 : _this$searchItems.length) === 0));
    }
  }, {
    key: "menuSearchIconClickedAnalytics",
    value: function menuSearchIconClickedAnalytics() {
      var _this$analyticsModel2;

      (_this$analyticsModel2 = this.analyticsModel) === null || _this$analyticsModel2 === void 0 ? void 0 : _this$analyticsModel2.dispatchSearchIconClickedConfirmation();
    }
  }, {
    key: "menuSearchItemClickedAnalytics",
    value: function menuSearchItemClickedAnalytics(searchValue, id, name, primaryCategory, subCategory1, subCategory2) {
      var _this$analyticsModel3;

      (_this$analyticsModel3 = this.analyticsModel) === null || _this$analyticsModel3 === void 0 ? void 0 : _this$analyticsModel3.dispatchSearchResultItemClickedConfirmation(searchValue, id, name, primaryCategory, subCategory1, subCategory2);
    }
  }, {
    key: "menuSearchAbSetupAnalytics",
    value: function menuSearchAbSetupAnalytics() {
      var _this$analyticsModel4;

      (_this$analyticsModel4 = this.analyticsModel) === null || _this$analyticsModel4 === void 0 ? void 0 : _this$analyticsModel4.dispatchMenuSearchAbTestConfirmation(!this.disableMenuSearch);
    }
  }, {
    key: "searchItems",
    get: function get() {
      //TODO: filter logic
      return this._searchText ? this._filteredItemListArray() : [];
    }
  }, {
    key: "searchInputBoxText",
    set: function set(text) {
      var _this9 = this;

      runInAction(function () {
        _this9._searchInputBoxText = text;
      });
    },
    get: function get() {
      return this._searchInputBoxText;
    }
  }, {
    key: "searchText",
    set: function set(_searchText) {
      var _this10 = this;

      runInAction(function () {
        _this10._searchText = _searchText;
      });
    },
    get: function get() {
      return this._searchText;
    }
  }, {
    key: "showSearchModal",
    set: function set(_showSearchModal) {
      var _this11 = this;

      runInAction(function () {
        _this11._showSearchModal = _showSearchModal;
      });
    },
    get: function get() {
      return this._showSearchModal;
    }
  }, {
    key: "showYouMayAlsoLikeBanner",
    get: function get() {
      var _this$_appAttributes16;

      return new BrandRules((_this$_appAttributes16 = this._appAttributes) === null || _this$_appAttributes16 === void 0 ? void 0 : _this$_appAttributes16.currentConceptCode).showRecommendationsInSearchModal();
    }
  }, {
    key: "disableMenuSearch",
    get: function get() {
      return this._isMenuSearchDisableBySession === "true" || this._isMenuSearchDisableByCookie === "true" || this._isMenuSearchDisabledByEvent === "true";
    }
  }, {
    key: "suggestedSearches",
    get: function get() {
      try {
        var menuSearchKeywordString = i18next.t("menu_search_suggested_keywords", {
          defaultValue: []
        });
        var suggestedItem = menuSearchKeywordString.split(",");
        return suggestedItem;
      } catch (error) {
        console.log(error, "error");
        return [];
      }
    }
  }, {
    key: "isMenuSearchDisableByRBWeb",
    get: function get() {
      var _this$_appAttributes17, _this$_appAttributes18;

      return ((_this$_appAttributes17 = this._appAttributes) === null || _this$_appAttributes17 === void 0 ? void 0 : (_this$_appAttributes18 = _this$_appAttributes17.configs) === null || _this$_appAttributes18 === void 0 ? void 0 : _this$_appAttributes18.disableMenuSearchForWeb) === "true" ? true : false;
    }
  }, {
    key: "isMenuSearchDisableByRBapp",
    get: function get() {
      var _this$_appAttributes19, _this$_appAttributes20;

      return ((_this$_appAttributes19 = this._appAttributes) === null || _this$_appAttributes19 === void 0 ? void 0 : (_this$_appAttributes20 = _this$_appAttributes19.configs) === null || _this$_appAttributes20 === void 0 ? void 0 : _this$_appAttributes20.disableMenuSearchForApp) === "true" ? true : false;
    }
  }]);

  return SearchModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_menuSearchList", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_showSearchModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_searchText", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_positionalIndexCounter", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_isMenuSearchDisableBySession", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "false";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_isMenuSearchDisableByCookie", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "false";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_isMenuSearchDisabledByEvent", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "false";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_searchInputBoxText", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _applyDecoratedDescriptor(_class.prototype, "searchItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchInputBoxText", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchInputBoxText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchText", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSearchModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSearchModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showYouMayAlsoLikeBanner", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showYouMayAlsoLikeBanner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableMenuSearch", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableMenuSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "suggestedSearches", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "suggestedSearches"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMenuSearchDisableByRBWeb", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMenuSearchDisableByRBWeb"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMenuSearchDisableByRBapp", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMenuSearchDisableByRBapp"), _class.prototype)), _class);
export { SearchModel as default };